import Card from './style'

interface IInfoCard {
  small?: boolean
  large?: boolean
  secondary?: boolean
  children?: JSX.Element[] | JSX.Element | string
  icon: any
  value: string
  filter?: any
  width?: number
  tertiary?: boolean
  quaternary?: boolean
  green?: boolean
  autoHeigth?: boolean
  textWhite?: any
  disabled?: boolean
  pic?: boolean
  backgroundColor?: string
}

export default function InfoCard(props: IInfoCard) {
  const { value, children, icon } = props
  return (
    <Card {...props}>
      <div className="ic-content">
        <img className="ic-icon" src={icon} alt="card icon" />
        <span className="ic-value">{value}</span>
      </div>
      <span className="ic-title">{children}</span>
    </Card>
  )
}
